/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Is_ActiveInputs */

const vi_tea_grade_is_active = /** @type {(inputs: Tea_Grade_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng`)
};

/**

* @param {Tea_Grade_Is_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_is_active = /** @type {((inputs?: Tea_Grade_Is_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Is_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_is_active(inputs)
});